export default __webpack_public_path__ + "static/media/RC-React-Inicial.df5b00c3.png";